import { render, staticRenderFns } from "./bonus-point.vue?vue&type=template&id=fe8fa2ca"
import script from "./bonus-point.vue?vue&type=script&lang=js"
export * from "./bonus-point.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports